module.exports = "<h1>Forbidden Access</h1>\n"